import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { GetVendorProfileResponse, getVendorProfile } from '@src/lib/api/vendors/getVendorProfile'
import { AxiosError } from 'axios'
import { ErrorResponse } from 'react-router-dom'

const useGetVendorProfileQuery = (
	vendorNo: string,
	options: UseQueryOptions<
		GetVendorProfileResponse,
		AxiosError<ErrorResponse>,
		GetVendorProfileResponse,
		string[]
	>,
) => {
	return useQuery(createKey(vendorNo), getVendorProfile, {
		...options,
	})
}

const createKey = (vendorNo: string) => ['vendor-profile', vendorNo]

export default useGetVendorProfileQuery
